import React from "react";
import { motion } from "framer-motion";
import { Container } from "react-bootstrap";
import ABOUT from "assets/about-us.png";
import TEAM1 from "assets/team-1.png";
import TEAM2 from "assets/team-2.png";
import styles from "./about.module.scss";
export const About = () => {
  return (
    <div className={styles.about_container}>
      <Container>
        <div className="p-4 text-end">
          <div className="d-flex flex-column justify-content-center align-items-center text-center my-2">
            <div className="col-md-4 my-3 ">
              <motion.div
                initial={{ y:-50 }}
                whileInView={{ y: 0 }}
                transition={{ duration: 0.4 }}
              >
                <img
                  loading="lazy"
                  src={ABOUT}
                  alt="poolban.ir team"
                  width={"100%"}
                />
              </motion.div>
            </div>
            <h1 className="font-bold my-2" dir="rtl">
              واحد خدمات درگاه الکترونيک «پولبان»
            </h1>
            <p dir="rtl">
              واحد خدمات درگاه الکترونيک «پولبان» زيرمجموعه واحد مستقل راهبردي
              «فناوری های مالی» شرکت آرايه ايده های هوشمند آسيا است که از سال
              <strong> 1399 </strong> در بدنه شرکت <strong> «آرايه» </strong>
              استقرار يافته است. شرکت آرايه يک شرکت دانش بنيان در حوزه پرداخت
              الکترونيک و سامانه های هوشمند حمل و نقل (ITS) است که به عنوان يک
              شرکت طراح و مجری راهکارهای جامع پرداخت خرد شهری به ويژه در بخش
              سيستمهای پرداخت کرايه و بهای خدمات الکترونيک شهری در صنعت شناخته
              شده است. با اضافه شدن سرويس درگاه های پرداخت اينترنتی و موبايلی
              چرخه خدمات پرداخت خرد شرکت آرايه که مبتنی بر ابزارهای پرداخت متنوع
              من جمله انواع کارتهای هوشمند غير تماسی و توکنهای بارکد دوبعدی می
              باشد تکميل گرديد.{" "}
            </p>
          </div>
        </div>
      </Container>
      <div className={styles.background_color}>
        <Container>
          <div className="my-5 d-flex gap-5 text-end">
            <div className="col-md-4 d-none d-md-block">
              <motion.div
                initial={{ scale: 0 }}
                whileInView={{ scale: 1.1 }}
                transition={{ duration: 0.4 }}
              >
                <img
                  loading="lazy"
                  src={TEAM1}
                  alt="poolban.ir team"
                  width={"100%"}
                />
              </motion.div>
            </div>
            <div>
              <h1 className="font-bold"> مشتريان ما </h1>
              <p dir="rtl">
                امروزه بزرگترين مشتريان «پولبان» کلانشهرها و شهرهای کوچک و
                متوسطی هستند که از راهکارهای پرداخت خرد شهری «آرايه» به ويژه در
                بخش حمل و نقل عمومی خود استفاده می کنند و «تلفن همراه» به عنوان
                قلب تپنده مديريت حسابهای شهروندی چند منظوره در آنها تبديل به
                ابزار اول پرداخت و ارائه سرويسهای اطلاع رسانی شده است.
              </p>
            </div>
          </div>
          <div className="my-5 d-flex gap-5 text-end">
            <div>
              <h1 className="font-bold">خدمات ما</h1>
              <p>
                لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با
                استفاده از طراحان گرافیک است، چاپگرها و متون بلکه روزنامه و مجله
                در ستون و سطرآنچنان که لازم است، و برای شرایط فعلی تکنولوژی مورد
                نیاز، و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد،
                کتابهای زیادی در شصت و سه درصد گذشته حال و آینده، شناخت فراوان
                جامعه و متخصصان را می طلبد، تا با نرم افزارها شناخت بیشتری را
                برای طراحان رایانه ای علی الخصوص طراحان خلاقی، و فرهنگ پیشرو در
                زبان فارسی ایجاد کرد، در این صورت می توان امید داشت که تمام و
                دشواری موجود در ارائه راهکارها، و شرایط سخت تایپ به پایان رسد و
                زمان مورد نیاز شامل حروفچینی دستاوردهای اصلی، و جوابگوی سوالات
                پیوسته اهل دنیای موجود طراحی اساسا مورد استفاده قرار گیرد.لورم
                ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با
                استفاده از طراحان گرافیک است، چاپگرها و متون بلکه روزنامه و مجله
                در ستون و سطرآنچنان که لازم است، و برای شرایط فعلی تکنولوژی مورد
                نیاز، و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد،
                کتابهای زیادی در شصت و سه درصد گذشته حال و آینده، شناخت فراوان
                جامعه و متخصصان را می طلبد، تا با نرم افزارها شناخت بیشتری را
                برای طراحان رایانه ای علی الخصوص طراحان خلاقی، و فرهنگ پیشرو در
                زبان فارسی ایجاد کرد، در این صورت می توان امید داشت که تمام و
                دشواری موجود در ارائه راهکارها، و شرایط سخت تایپ به پایان رسد و
                زمان مورد نیاز شامل حروفچینی دستاوردهای اصلی، و جوابگوی سوالات
                پیوسته اهل دنیای موجود طراحی اساسا مورد استفاده قرار گیرد.
              </p>
            </div>
            <div className="col-md-2 d-none d-md-block">
              <motion.div
                initial={{ scale: 0 }}
                whileInView={{ scale: 1.3 }}
                transition={{ duration: 0.4 }}
              >
                <img
                  loading="lazy"
                  src={TEAM2}
                  alt="poolban.ir team"
                  width={"100%"}
                />
              </motion.div>
            </div>
          </div>
        </Container>
      </div>
    </div>
  );
};
